import { forwardRef, type SVGProps } from 'react';

export interface CloudIconProps extends Omit<SVGProps<SVGSVGElement>, 'css'> {}

export const CloudIcon = forwardRef<SVGSVGElement, CloudIconProps>((props, ref) => (
  <svg ref={ref} {...props} aria-hidden="true" fill="none" viewBox="0 0 16 16">
    <path
      d="M7.79736 2.44971C9.94552 2.44991 11.6607 4.16492 11.8706 6.34717C13.5366 6.62116 14.7495 8.17053 14.7495 9.92725C14.7495 11.8121 13.3535 13.457 11.4995 13.5454V13.5503H4.24951L4.24658 13.5464C2.36962 13.4834 0.949707 11.8277 0.949707 9.92725C0.949744 8.18154 2.15126 6.63122 3.7749 6.3501C3.97739 4.17519 5.63901 2.44971 7.79736 2.44971ZM7.79736 3.55029C6.18644 3.55029 4.854 4.93505 4.854 6.79932V6.85498C4.85385 7.15861 4.60786 7.40479 4.3042 7.40479C3.12026 7.40496 2.05033 8.50621 2.05029 9.92725C2.05029 11.3413 3.11377 12.4494 4.35693 12.4497H11.3423C12.5856 12.4497 13.6499 11.3415 13.6499 9.92725C13.6499 8.51305 12.5856 7.40479 11.3423 7.40479C11.0387 7.40473 10.7926 7.15857 10.7925 6.85498V6.79932C10.7925 4.94636 9.41848 3.55052 7.79736 3.55029Z"
      fill="currentColor"
    />
  </svg>
));

CloudIcon.displayName = 'CloudIcon';
